<!-- eslint-disable vue/no-deprecated-v-on-native-modifier -->
<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'"
    :color="'#1B1B1B'"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    :mobile-break-point="960"
    app
    mini-variant-width="80"
    width="300"
    v-bind="$attrs"
    @mouseleave.native="drawerHover = false"
    @mouseover.native="drawerHover = true"
  >
    <template v-slot:img="props">
      <v-img :gradient="`to bottom, ${barColor}`" v-bind="props" />
    </template>

    <div style="position: relative">
      <v-list-item two-line>
        <v-list-item-content align="center" justify="center">
          <router-link to="/home">
            <v-img v-if="isMiniVariant" width="20" src="@/assets/simbolo-geon.svg" />
            <v-img v-else width="90" src="@/assets/logo-geon-horizontal.svg" />
          </router-link>
        </v-list-item-content>
      </v-list-item>

      <v-divider class="mb-1" />

      <v-list id="drawer-section-profile" dense nav>
        <base-item-group
          v-if="profile"
          :item="profile"
          class="drawerItemList mr-1"
          :recolherSubMenus="!drawerHover ? false : true"
        />
      </v-list>

      <v-divider class="mb-2" />

      <div @click.stop="openDialogChangeCompany()">
        <v-list dense nav>
          <base-item :href="undefined" :item="selectedCompany" class="mr-1" />
        </v-list>
      </div>

      <v-divider class="mb-2" />

      <v-list expand nav>
        <!-- Style cascading bug  -->
        <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
        <div />

        <template v-for="(item, i) in computedItems">
          <base-item-group v-if="item.children" :key="`group-${i}`" :item="item">
            <!--  -->
          </base-item-group>

          <base-item
            v-else
            :key="`item-${i}`"
            :item="item"
            :idElement="'drawer-section-' + item.title.toLowerCase().replace(/ /g, '')"
            class="mr-1"
          />
        </template>

        <!-- Style cascading bug  -->
        <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
        <div />
      </v-list>

      <v-divider class="mb-1" style="margin-top: 10px" />
    </div>

    <!-- <div
      v-if="drawerExpanded || (drawerHover && !drawerExpanded)"
      :style="'position:' + getCssLogoPositionLogo + ';width:300px; bottom:0'"
    >
      <div
        align="center"
        justify="center"
      >
        <v-img
          width="180"
          height="80"
          src="@/assets/logo_norven_negativo_tagline.png"
        />
      </div>

      <div
        align="center"
        justify="center"
        class="mb-3 mt-n5"
      >
        <v-btn
          color="white"
          dark
          icon
          min-width="0"
          href="https://norven.com.br"
          target="_blank"
        >
          <v-icon
            size="25"
            color="white"
          >
            mdi-web
          </v-icon>
        </v-btn>
        <v-btn
          color="white"
          dark
          icon
          min-width="0"
          href="https://www.linkedin.com/company/norvenbr/mycompany"
          target="_blank"
        >
          <v-icon
            size="25"
            color="white"
          >
            mdi-linkedin
          </v-icon>
        </v-btn>
        <v-btn
          color="white"
          dark
          icon
          min-width="0"
          href="https://www.youtube.com/channel/UCq_3TspPFJhJogl0ug7rmYQ"
          target="_blank"
        >
          <v-icon
            size="25"
            color="white"
          >
            mdi-youtube
          </v-icon>
        </v-btn>
      </div>
    </div>
    <div
      v-else
      style="position: fixed; bottom: 0px; width: 80px"
      align="center"
      justify="center"
    >
      <router-link to="/">
        <v-img
          width="80"
          height="80"
          src="@/assets/norven_simbolo_branco.png"
        />
      </router-link>
    </div> -->

    <v-dialog v-model="dialogChangeCompany" max-width="340px" eager>
      <v-card>
        <v-card-title class="headline">Mudar Empresa</v-card-title>
        <v-card-text>
          <v-row class="mx-auto">
            <select-company
              ref="refSelectCompany"
              style="min-width: 100%"
              :changeCompany="false"
              @selected="handleCompanySelected"
              @companySelected="changeSelectedCompany($event)"
            />
          </v-row>
          <v-row class="mx-auto">
            <select-all-bdgd-versions
              ref="refSelectBdgdVersionId"
              style="min-width: 100%"
              :showIcon="false"
              :companyId="newSelectedCompanyId"
              @bdgdVersionSelected="handleBdgdVersionSelected"
            />
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="triggerSelectCompanyEvent()">Confirmar</v-btn>
          <v-btn color="primary" text @click.stop="dialogChangeCompany = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-navigation-drawer>
</template>

<script>
  import { mapState } from 'vuex';
  import AuthService from '@/services/AuthService';
  import ReleasesNovidadesService from '@/services/ReleasesNovidadesService';
  import SelectCompany from '@/components/general/SelectCompany';
  import SelectAllBdgdVersions from '@/components/general/SelectAllBdgdVersions';
  import profilePermissionsMixin from '@/mixins/profilePermissionsMixin';

  export default {
    name: 'DashboardCoreDrawer',
    components: {
      SelectCompany,
      SelectAllBdgdVersions
    },
    mixins: [profilePermissionsMixin],
    props: {
      expandOnHover: {
        type: Boolean,
        default: false
      },
      drawerExpanded: {
        type: Boolean,
        default: false
      }
    },

    data: () => ({
      drawerHover: false,
      profilePic: null,
      profile: null,
      userIsAdmin: false,
      dialogChangeCompany: false,
      newSelectedCompanyId: null,
      newSelectedBdgdVersion: null,
      isMiniVariant: false,
      releasesNaoVisualizadas: 0
    }),

    computed: {
      ...mapState(['barColor', 'barImage']),

      drawer: {
        get() {
          return this.$store.state.drawer;
        },
        set(val) {
          this.$store.commit('SET_DRAWER', val);
        }
      },

      computedItems() {
        let items = [];

        items.push({
          icon: '$dashboard',
          title: 'Dashboard',
          to: '/home'
        });

        if (
          this.accessReleased('GERACAO_DA_BDGD') &&
          (this.accessReleased('IMPORTACOES_DE_BDGD') ||
            this.accessReleased('RELATORIOS_HISTORICO') ||
            this.accessReleased('VALIDACOES_DA_BDGD_HISTORICO') ||
            this.accessReleased('VALIDACOES_INDQUAL') ||
            this.accessReleased('VALIDACOES_SAMP') ||
            this.accessReleased('ATUALIZACOES_DE_BDGD') ||
            this.accessReleased('CONECTIVIDADE_E_PERDAS_TECNICAS') ||
            this.accessReleased('EXPORTAR_BDGD_HISTORICO'))
        ) {
          items.push({
            icon: '$add_banco_dados',
            title: 'Geração da BDGD',
            to: '/geracao-bdgd'
          });
        }

        if (
          this.accessReleased('CONECTIVIDADE_E_PERDAS_TECNICAS') &&
          (this.accessReleased('CARREGAR_BDGD_HISTORICO') ||
            this.accessReleased('PREENCHER_TABELAS_OPERACIONAIS_HISTORICO') ||
            this.accessReleased('SEQUENCIAMENTO_ELETRICO') ||
            this.accessReleased('MALHA') ||
            this.accessReleased('FASEAMENTO') ||
            this.accessReleased('PROG_GEOPERDAS_ANEEL') ||
            this.accessReleased('EXPORTAR_BDGD_HISTORICO'))
        ) {
          items.push({
            icon: '$poste_transmissao',
            title: 'Perdas Técnicas',
            to: '/perdas-tecnicas'
          });
        }

        if (this.accessReleased('RELATORIOS_HISTORICO')) {
          items.push({
            icon: '$documento',
            title: 'Relatórios',
            to: '/relatorios/historico'
          });
        }

        if (
          this.accessReleased('POWER_UPS') &&
          (this.accessReleased('SIGR_COMPARA_HISTORICO') || this.accessReleased('CONCILIACOES_HISTORICO'))
        ) {
          items.push({
            icon: '$energia',
            title: 'Power Ups',
            to: '/powerups'
          });
        }

        if (
          this.accessReleased('MAPAS') &&
          (this.accessReleased('LAYERS_PERSONALIZADOS_HISTORICO') ||
            this.accessReleased('CANVAS_HISTORICO') ||
            this.accessReleased('ENTIDADES_GEOGRAFICAS_DA_BDGD_VISUALIZAR_MAPA') ||
            this.accessReleased('ENTIDADES_GEOGRAFICAS_COMPARAR_NO_MAPA') ||
            this.accessReleased('SETORIZACOES_HISTORICO') ||
            this.accessReleased('ANALISES_SETORIZADAS_HISTORICO'))
        ) {
          items.push({
            icon: '$busca_mapa',
            title: 'Criação de Mapas',
            to: '/mapas'
          });
        }

        if (
          this.accessReleased('DADOS') &&
          (this.accessReleased('ARQUIVOS_DE_DADOS') ||
            this.accessReleased('IMPORTACOES_DE_DADOS') ||
            this.accessReleased('CARGAS_CSV') ||
            this.accessReleased('IMPORTACOES_INDQUAL') ||
            this.accessReleased('VERSOES_DA_BDGD_HISTORICO') ||
            this.accessReleased('CARGAS_DADOS_GEOGRAFICOS') ||
            this.accessReleased('EXPURGOS_DE_BDGD_HISTORICO'))
        ) {
          items.push({
            icon: '$banco_dados',
            title: 'Dados',
            to: '/dados'
          });
        }

        items.push({
          icon: 'mdi-newspaper-variant',
          title: 'Releases e Novidades',
          to: '/releases-novidades',
          badge: this.releasesNaoVisualizadas || undefined
        });

        if (
          this.accessReleased('ADMINISTRACAO') &&
          (this.accessReleased('USUARIOS_LISTAR') ||
            this.accessReleased('PERFIS_USUARIOS_LISTAR') ||
            this.accessReleased('LOGS_ACESSOS_USUARIOS_LISTAR') ||
            this.accessReleased('EMPRESAS_LISTAR') ||
            this.accessReleased('GEOPERDAS_SERVIDORES_BANCOS_DADOS_LISTAR') ||
            this.accessReleased('SERVIDORES_EC2_NA_AWS_LISTAR') ||
            this.accessReleased('SERVIDORES_RDS_NA_AWS_LISTAR') ||
            this.accessReleased('RELATORIOS_MODELOS_HISTORICO') ||
            this.accessReleased('VALIDACOES_BDGDS_MODELOS_HISTORICO') ||
            this.accessReleased('TABELAS_X_DISCO'))
        ) {
          items.push({
            icon: '$configuracoes',
            title: 'Administração',
            to: '/admin'
          });
        }

        return items.map(this.mapItem);
      },

      getCssLogoPositionLogo() {
        let heightDrawer = document.getElementById('core-navigation-drawer');
        heightDrawer = heightDrawer ? heightDrawer.offsetHeight : 645;
        return heightDrawer <= 644 ? 'relative' : 'fixed';
      },

      selectedCompany() {
        return {
          sigla: this.$store.getters.getCompanyAcronym,
          title: this.$store.getters.getCompanyName,
          id: this.$store.getters.getCompanyId
        };
      }
    },

    mounted() {
      this.getProfile();
      this.getUserIsAdmin();
      this.getReleasesNaoVisualizadas();
      this.$root.$on('releases-visualizadas', () => (this.releasesNaoVisualizadas = 0));

      const drawerEl = document.getElementById('core-navigation-drawer');
      if (drawerEl) {
        // inicializa
        this.isMiniVariant = drawerEl.classList.contains('v-navigation-drawer--mini-variant');

        // observa mudanças de atributos (classes)
        const mo = new MutationObserver((mutations) => {
          mutations.forEach((m) => {
            if (m.attributeName === 'class') {
              this.isMiniVariant = drawerEl.classList.contains('v-navigation-drawer--mini-variant');
            }
          });
        });
        mo.observe(drawerEl, { attributes: true });

        // opcional: guarda referência se quiser disconnect depois
        this._drawerClassObserver = mo;
      }
    },

    beforeUnmount() {
      if (this._drawerClassObserver) this._drawerClassObserver.disconnect();
      this.$root.$off('releases-visualizadas');
    },

    methods: {
      async getProfile() {
        this.profile = {
          avatar: true,
          img: false,
          group: '/perfil',
          title: this.$store.getters.getUserName,
          children: [
            {
              icon: '$usuario',
              to: 'index',
              title: 'Perfil'
            },
            {
              icon: '$saida',
              to: 'logout',
              title: 'Logout'
            }
          ]
        };
      },

      getUserIsAdmin() {
        AuthService.userIsAdmin().then((userIsAdmin) => (this.userIsAdmin = userIsAdmin));
      },

      getReleasesNaoVisualizadas() {
        ReleasesNovidadesService.contarNaoVisualizadas()
          .then(({ data }) => (this.releasesNaoVisualizadas = data))
          .catch(() => {});
      },

      mapItem(item) {
        return {
          ...item,
          children: item.children ? item.children.map(this.mapItem) : undefined,
          title: this.$t(item.title)
        };
      },

      openDialogChangeCompany() {
        this.dialogChangeCompany = true;
        this.$refs.refSelectCompany.company = this.selectedCompany.id;
        this.newSelectedCompanyId = this.selectedCompany.id;
      },

      handleCompanySelected(companyId) {
        this.newSelectedCompanyId = companyId;
      },

      handleBdgdVersionSelected(bdgdVersion) {
        this.newSelectedBdgdVersion = bdgdVersion;
      },

      triggerSelectCompanyEvent() {
        this.$refs.refSelectCompany.companySelected(this.$refs.refSelectCompany.company);
      },

      async changeSelectedCompany(company) {
        this.dialogChangeCompany = false;
        await this.$store.dispatch('setSelectedCompany', company);
        await this.$store.dispatch('setUserIsAdmin');

        if (this.newSelectedBdgdVersion) {
          this.$store.dispatch('setUserSelectedCompanyBdgdVersionId', this.newSelectedBdgdVersion.id);
        }
        setTimeout(() => {
          location.reload();
        }, 100);
      }
    },

    watch: {
      '$vuetify.breakpoint.smAndDown'(val) {
        this.$emit('update:expandOnHover', !val);
      }
    }
  };
</script>

<style lang="sass">
  @import '~vuetify/src/styles/tools/_rtl.sass'

  #core-navigation-drawer
    .v-navigation-drawer__content
      &::-webkit-scrollbar
        width: 7px

      &::-webkit-scrollbar-track
        background: transparent

      &::-webkit-scrollbar-thumb
        background: #3a3a3a
        border-radius: 10px

      &::-webkit-scrollbar-thumb:hover
        background: #5a5a5a

  #core-navigation-drawer
    &.v-navigation-drawer--mini-variant
      .v-list-item
        justify-content: flex-start !important

      .v-list-group--sub-group
        display: block !important

    .v-list-group__header.v-list-item--active:before
      opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
          margin-right: 24px
          margin-left: 12px !important

        +rtl()
          margin-left: 24px
          margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 10px

    .v-list-group--sub-group
      .v-list-item
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-right: 0

        +rtl()
          padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 8px

          +rtl()
            margin-left: 8px
</style>
